// FRONTENDO: do not disable buttons when doing loading={true}.
// Instead do [aria-busy="true"], remove [phx-click], add onclick="return false;"
// and revert attr mods on loading={false}.

import Hook from "../utils/hook"

export default Hook(`Button`, {
  setLoading(val) {
    this.setDisabled(val)

    if (val) this.classAdd(`is-loading`)
    else this.classRemove(`is-loading`)
  },

  setDisabled(val) {
    if (val) this.attributeSet(`disabled`, `disabled`).classAdd(`is-disabled`)
    else this.attributeRemove(`disabled`).classRemove(`is-disabled`)
  },
})
